import axios from './axios';

/**
 * Settings API Client
 * Handles all API calls related to system settings
 */
export const settingsApi = {
  /**
   * Get all settings
   */
  getAll: () => axios.get('/settings'),

  /**
   * Get settings by category
   * @param {string} category - Category name (smtp, application, email_templates)
   */
  getByCategory: (category) => axios.get(`/settings/${category}`),

  /**
   * Update settings with optional validation
   * @param {Object} settings - Settings object organized by category
   * @param {boolean} validate - Whether to validate SMTP connection before saving
   */
  update: (settings, validate = false) =>
    axios.put('/settings' + (validate ? '?validate=true' : ''), settings),

  /**
   * Test SMTP connection (legacy endpoint)
   * @param {Object} credentials - SMTP credentials to test
   */
  testSmtp: (credentials) => axios.post('/settings/test-smtp', credentials),

  /**
   * Get email provider status
   * Returns active provider, configuration status, and source
   */
  getEmailProviderStatus: () => axios.get('/settings/email-provider/status'),

  /**
   * Test email provider connection
   * @param {Object} data - { provider: 'smtp'|'graph', config: {...}, test_recipient: '...' }
   */
  testEmailProvider: (data) => axios.post('/settings/test-email-provider', data),

  /**
   * Reset settings to defaults from .env
   */
  resetDefaults: () => axios.post('/settings/reset-defaults'),
};

export default settingsApi;